import { iRecordType } from "./iRecordType";

export class DBUser implements iRecordType
{
    public id:string;
    public email:string;
    public username:string;
    public enabled:boolean;
    public roles:Array<string>;
    public className="User";

    public static apiName:string="User";

    constructor(values: Object = {}) {          
        Object.assign(this, values);          
    }
}


// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/model/user.ts